import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslation } from 'react-i18next'
import type { FieldValues, Resolver } from 'react-hook-form'
import type { ZodType } from 'zod'

import { translateFieldErrors } from '_utils/translated-field-errors.utils'

export const useTranslatedResolver = <TValues extends FieldValues>(
  schema: ZodType,
  keyPrefix: string
): Resolver<TValues> => {
  const { t } = useTranslation('core')
  const base = zodResolver(schema as never) as unknown as Resolver<TValues>
  const translated = async (...args: Parameters<Resolver<TValues>>) => {
    const result = await base(...args)
    return {
      ...result,
      errors: translateFieldErrors(result.errors, (code) => String(t(`${keyPrefix}.${code}`))),
    }
  }
  return translated as Resolver<TValues>
}
